import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider.jsx";
import ProtectedRoute from "./ProtectedRoute.js";
import PrivateLayout from "../../layouts/private/PrivateLayout.jsx";
import PrivateCleanLayout from "../../layouts/private/PrivateCleanLayout.jsx";
import PublicLayout from "../../layouts/public/PublicLayout.jsx";

import ChannelPageList from "../../features/channels/overview/ChannelOverviewPage.jsx";
import ChannelPageOptions from "../../features/channels/options/index.jsx";
import ChannelIntegrationQrCodePage from "../../features/channels/types/WhatsappWeb/Integration/QRCode/ChannelIntegrationQrCodePage.jsx";
import CreateIntegrationAlcancePage from "../../features/channels/types/Sms/Integration/Alcance/CreateIntegrationAlcancePage.jsx";
import CreateIntegrationSesPage from "../../features/channels/types/Email/Integration/Ses/CreateIntegrationSesPage.jsx";
import CreateIntegrationEmbeddedPage from "../../features/channels/types/WhatsappApi/Integration/EmbeddedSignup/CreateIntegrationEmbeddedPage.jsx";
import ViewConfigChannel from "../../features/channels/settings/index.js";

import TemplatesPageList from "../../features/templates/overview/TemplatesOverviewPage.jsx";
import TemplatePageAdd from "../../features/templates/options/index.jsx";
import TemplatePageChannelAdd from "../../features/templates/create/index.js";

import IntegrationsPageAdd from "../../features/integrations/options/index.jsx";
import AddIntegration from "../../features/integrations/AddIntegration.js"

import LoginPage from "../../features/auth/LoginPage.jsx";
import PasswordRecoveryPage from "../../features/auth/PasswordRecoveryPage.jsx";
import DashboardPage from "../../features/dashboard/index.js";

import CampaignCreatePage from "../../features/campaigns/create/CampaignCreatePage.jsx";
import CampaignEditPage from "../../features/campaigns/edit/CampaignEditPage.jsx";
import CampaignPage from "../../features/campaigns/overview/index.js";
import CampaignViewPage from "../../features/campaigns/view/CampaignViewPage.jsx";

import Sheets from "../../features/sheets/overview/index.js";
import AddSheetsOptions from "../../features/sheets/options/index.jsx";
import PageAddGoogleSheets from "../../features/sheets/types/GoogleSheets/create/addGoogleSheets.jsx";
import PageAddExcel from "../../features/sheets/types/Excel/create/addExcel.jsx";
import PageAddApiRest from "../../features/sheets/types/ApiRest/create/addApiRest.jsx";
import AddSheetsIntegrationInvoice from "../../features/sheets/types/Erps/create/addSheetsIntegrationInvoice.js";

import ProfileSetupPage from "../../features/profile/ProfileSetupPage.jsx";
import SignUp from "../../features/auth/SignupPage.jsx";
import VerifyEmailPage from "../../features/auth/VerifyEmailPage.jsx"

import NotFound from "../../shared/components/common/ui/NotFound/index.jsx";
import SessionExpired from "../../shared/components/common/ui/SessionExpired/index.jsx";

import SupportAccessPage from "../../features/auth/SupportAccessPage.jsx";
import ResetRequiredPasswordPage from "../../features/auth/ResetRequiredPasswordPage.jsx";

function RootRedirect() {
  const { isAuthenticated, status } = useAuth();

  if (status === "booting") return null;

  return isAuthenticated
    ? <Navigate to="/painel" replace />
    : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>

      {/* ================= ROOT ================= */}

      <Route element={<PublicLayout />}>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/esqueci-senha" element={<PasswordRecoveryPage />} />
        <Route path="/cadastro" element={<SignUp />} />
        <Route path="/support-login" element={<SupportAccessPage />} />
        <Route path="/reset-senha" element={<ResetRequiredPasswordPage />} />
        <Route path="/logout" element={<SessionExpired />} />
      </Route>

      {/* ================= PROTECTED ================= */}

      <Route element={<ProtectedRoute />}>
        <Route element={<PrivateCleanLayout />}>
          <Route path="/verificar-email" element={<VerifyEmailPage />} />
        </Route>

        <Route element={<PrivateLayout />}>

          <Route path="/painel" element={<DashboardPage />} />
          <Route path="/perfil" element={<ProfileSetupPage />} />

          <Route path="/canais" element={<ChannelPageList />} />
          <Route path="/canais/adicionar" element={<ChannelPageOptions />} />
          <Route path="/canais/adicionar/whatsapp-web" element={<ChannelIntegrationQrCodePage />} />
          <Route path="/canais/adicionar/whatsapp-api" element={<CreateIntegrationEmbeddedPage />} />
          <Route path="/canais/adicionar/sms" element={<CreateIntegrationAlcancePage />} />
          <Route path="/canais/adicionar/email" element={<CreateIntegrationSesPage />} />
          <Route path="/canais/configurar" element={<ViewConfigChannel />} />

          <Route path="/modelos" element={<TemplatesPageList />} />
          <Route path="/modelos/canal" element={<TemplatePageAdd />} />
          <Route path="/modelos/canal/whatsapp-web" element={<TemplatePageChannelAdd channel="whatsapp_web" />} />
          <Route path="/modelos/canal/whatsapp-api" element={<TemplatePageChannelAdd channel="whatsapp_api" />} />
          <Route path="/modelos/canal/email" element={<TemplatePageChannelAdd channel="email" />} />
          <Route path="/modelos/canal/sms" element={<TemplatePageChannelAdd channel="sms" />} />

          <Route path="/listagens" element={<Sheets />} />
          <Route path="/listagens/adicionar" element={<AddSheetsOptions />} />
          <Route path="/listagens/adicionar/google" element={<PageAddGoogleSheets />} />
          <Route path="/listagens/adicionar/api" element={<PageAddApiRest />} />
          <Route path="/listagens/adicionar/excel" element={<PageAddExcel />} />
          <Route path="/listagens/adicionar/:integration" element={<AddSheetsIntegrationInvoice />} />
          <Route path="/listagens/adicionar/:integration/faturas em aberto" element={<AddSheetsIntegrationInvoice />} />

          <Route path="/campanhas" element={<CampaignPage />} />
          <Route path="/campanhas/adicionar" element={<CampaignCreatePage />} />
          <Route path="/campanhas/:id/editar" element={<CampaignEditPage />} />
          <Route path="/campanhas/:id" element={<CampaignViewPage />} />

          <Route path="/integrações" element={<IntegrationsPageAdd />} />
          <Route path="/integrações/adicionar" element={<AddIntegration />} />

        </Route>
      </Route>

      {/* ================= FALLBACK ================= */}

      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}

export default AppRoutes;
